import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useMemo } from 'react';

const ReportingInternList = ({ listData, ...props }) => {
    const sortedData = useMemo(() => {
        return [...listData.data].sort((a, b) => a.value.localeCompare(b.value));
    }, [listData.data]);
    return (
        <>
            <strong>{listData.label}</strong>
            <Autocomplete
                value={listData.value}
                onChange={(event, newValue) => {
                    props.handleDataChange(newValue);
                }}
                getOptionLabel={option => option.value}
                getOptionSelected={(option, value) => option.id === value.id}
                options={sortedData}
                noOptionsText={"Aucun client trouvé."}
                renderInput={(params) => <TextField {...params} variant="outlined" />}
                disableClearable
                loading={listData.isLoading}
                loadingText="chargement..."
            />
        </>
    )
}

export default ReportingInternList